import * as d3 from 'd3-selection'
import score from './score.js'
import title from './title.js'
import subtitle from './subtitle.js'

export default function (dimensions, fontSize) {

  var draw = function (selection) {
    selection.each(function (data) {
      var labels = d3.select(this)
                    .selectAll('g.labels')
                    .data(function (d) {
                      return [d]
                    })
        , enter = labels.enter()
                        .append('g')
                          .attr('class', 'labels')
        , _labels = labels.merge(enter)
                          .attr('transform', 'translate(' + (dimensions.gaugeWidth / 2 + dimensions.margin.left) + ',' +
                                                            (dimensions.gaugeHeight + dimensions.margin.top + dimensions.labelOffset) + ')')
                          .call(title(dimensions, fontSize))
                          .call(subtitle(dimensions, fontSize))
                          .call(score(dimensions, fontSize))
    })
  }

  return draw
}
